import "../styles/main.css";

function Faculty({ mode }) {
  return (
    <div className="facilities">

      <h2>Our Faculty</h2>
      <p className="subtitle">
        Meet our experienced and dedicated teaching staff.
      </p>

      <div className="facility-grid">

        {/* 1 */}
        <div className="facility-card">
          <h3>Prof. Varsha M. Bagul</h3>
          <p>M.A., B.Ed., M.Phil.</p>
          <p><b>Principal (Hindi)</b></p>
        </div>

        {/* 2 */}
        <div className="facility-card">
          <h3>Prof. Bhagwat S. B.</h3>
          <p>M.A., B.Ed.</p>
          <p><b>Assistant Professor (English)</b></p>
        </div>

        {/* 3 */}
        <div className="facility-card">
          <h3>Prof. Hiwale Aarti R.</h3>
          <p>M.A., M.Lib.</p>
          <p><b>Librarian</b></p>
        </div>

        {/* 4 */}
        <div className="facility-card">
          <h3>Prof. Raut A. K.</h3>
          <p>M.A., B.Ed.</p>
          <p><b>Assistant Professor (Marathi / Political Science)</b></p>
        </div>

        {/* 5 */}
        <div className="facility-card">
          <h3>Prof. Tajne P. D.</h3>
          <p>M.A., B.Ed., Ph.D., NET</p>
          <p><b>Assistant Professor (Sociology)</b></p>
        </div>

        {/* 6 */}
        <div className="facility-card">
          <h3>Prof. Chavan P. S.</h3>
          <p>M.A., B.Ed.</p>
          <p><b>Assistant Professor (Economics)</b></p>
        </div>

        {/* 7 */}
        <div className="facility-card">
          <h3>Prof. Tabekar Vijay</h3>
          <p>M.Sc., B.Ed.</p>
          <p><b>Assistant Professor (Chemistry)</b></p>
        </div>

        {/* 8 */}
        <div className="facility-card">
          <h3>Prof. Payal A. Bankar</h3>
          <p>M.Sc., B.Ed.</p>
          <p><b>Assistant Professor (Zoology)</b></p>
        </div>

        {/* 9 */}
        <div className="facility-card">
          <h3>Prof. Jadhav</h3>
          <p>M.Sc.</p>
          <p><b>Assistant Professor (Physics)</b></p>
        </div>

        {/* 10 */}
        <div className="facility-card">
          <h3>Prof. Waghchoure F. N.</h3>
          <p>M.Com., B.Ed.</p>
          <p><b>Assistant Professor (Commerce)</b></p>
        </div>

        {/* 11 */}
        <div className="facility-card">
          <h3>Prof. Mote A. E.</h3>
          <p>M.Com.</p>
          <p><b>Assistant Professor (Commerce)</b></p>
        </div>

      </div>

    </div>
  );
}

export default Faculty;